import { SessionExpiryDialog, getAuth0Expiry } from '@australiangreens/ag-internal-components';
import { useAuth0 } from '@auth0/auth0-react';
import { auth0ExpiryTimeAtom } from '@hooks/useApp';
import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { useIdleTimer, workerTimers } from 'react-idle-timer';
import { useUserDetails } from '@/hooks';

const MINUTE_LENGTH_MS = 60000;
const TIMEOUT_SHOW_DIALOG = 5 * MINUTE_LENGTH_MS;

const COORDINATOR_TIMEOUT_MS = 30 * MINUTE_LENGTH_MS;
const CALLER_TIMEOUT_MS = 30 * MINUTE_LENGTH_MS;

export default function Auth0SessionController() {
  const [auth0ExpiryTime, setAuth0ExpiryTime] = useAtom(auth0ExpiryTimeAtom);
  const [showSessionExpiry, setShowSessionExpiry] = useState(false);
  const { isAuthenticated, getAccessTokenSilently, logout } = useAuth0();
  const { data: userDetails } = useUserDetails();
  const { reset, message } = useIdleTimer({
    timeout: ['Principal Coordinator', 'Coordinator'].includes(userDetails?.userLevel ?? 'None')
      ? COORDINATOR_TIMEOUT_MS
      : CALLER_TIMEOUT_MS,
    timers: workerTimers,
    crossTab: true,
    promptBeforeIdle: TIMEOUT_SHOW_DIALOG,
    onPrompt: () => setShowSessionExpiry(true),
    onIdle: () => logout(),
    onMessage: (data) => {
      if (data === 'continue') setShowSessionExpiry(false);
    },
  });

  useEffect(() => {
    const updateExpiryTime = async () => {
      if (isAuthenticated) {
        const token = await getAccessTokenSilently();
        const tokenExp = getAuth0Expiry(token) * 1000;
        setAuth0ExpiryTime(tokenExp);
      }
    };

    updateExpiryTime();
  }, [getAccessTokenSilently, isAuthenticated, setAuth0ExpiryTime]);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentDate = new Date().getTime();
      const leftOver = auth0ExpiryTime - currentDate;
      if (leftOver < TIMEOUT_SHOW_DIALOG) {
        setShowSessionExpiry(true);
      }
      /*  Check timeout. */
    }, MINUTE_LENGTH_MS);
    return () => clearInterval(interval);
  }, [auth0ExpiryTime, setShowSessionExpiry]);

  return (
    <SessionExpiryDialog
      open={showSessionExpiry}
      setAuth0ExpiryTime={setAuth0ExpiryTime}
      closeHandler={() => {
        reset();
        message('continue');
        setShowSessionExpiry(false);
      }}
    />
  );
}
